<template>
  <div class="w-100">Job manually set to Reachable</div>
</template>

<script type="text/babel">
import BaseComponent from "./BaseComponent.vue";

export default {
  extends: BaseComponent,
};
</script>
